import { Icon, IconButton, Snackbar, SnackbarContent, withStyles } from '@material-ui/core';
import { amber, blue, green } from '@material-ui/core/colors';
import * as Actions from 'app/store/actions';
import classNames from 'classnames';
import React, { Component } from 'react';
import { MdClose } from 'react-icons/md';
import copy from "copy-to-clipboard";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

const styles = theme => ({
    root: {},
    success: {
        backgroundColor: green[600],
        color: '#ffffff'
    },
    error: {
        backgroundColor: theme.palette.error.dark,
        color: theme.palette.getContrastText(theme.palette.error.dark)
    },
    info: {
        backgroundColor: blue[600],
        color: '#ffffff'
    },
    warning: {
        backgroundColor: amber[600],
        color: '#ffffff'
    }
});

const variantIcon = {
    success: "check_circle",
    warning: "warning",
    error: "error_outline",
    info: "info"
};

class FuseMessage extends Component {
    render() {
        const { classes, options } = this.props;
        return (
            <Snackbar
                {...options}
                open={this.props.state}
                onClose={this.props.hideMessage}
                classes={{
                    root: classes.root
                }}
                ContentProps={{
                    variant: 'body2',
                    headlineMapping: {
                        body1: 'div',
                        body2: 'div'
                    }
                }}
            >
                <SnackbarContent
                    className={classNames(classes[options.variant])}
                    message={
                        <div className="flex items-center">
                            {variantIcon[options.variant] && (
                                <IconButton
                                    key="copy"
                                    aria-label="copy"
                                    className="p-6 mr-8"
                                    color="inherit"
                                    onClick={() => copy(options.message)}
                                >
                                    <Icon color="inherit">{variantIcon[options.variant]}</Icon>
                                </IconButton>
                            )}
                            {options.message}
                        </div>
                    }
                    action={[
                        <IconButton
                            key="close"
                            aria-label="Close"
                            className="p-6"
                            color="inherit"
                            onClick={this.props.hideMessage}
                        >
                            <MdClose />
                        </IconButton>
                    ]}
                />
            </Snackbar>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        hideMessage: Actions.hideMessage
    }, dispatch);
}

function mapStateToProps({ fuse }) {
    return {
        state: fuse.message.state,
        options: fuse.message.options
    }
}

export default withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(FuseMessage));
